function decode(value) {
  const base64 = value.replace(/-/g, "+").replace(/_/g, "/")
  return Uint8Array.from(atob(base64), character => character.charCodeAt(0))
}

function encode(value) {
  const binary = Array.from(new Uint8Array(value), byte => String.fromCharCode(byte)).join("")
  return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "")
}

export function creationOptions(options) {
  return {
    ...options,
    challenge: decode(options.challenge),
    user: { ...options.user, id: decode(options.user.id) },
    excludeCredentials: (options.excludeCredentials || []).map(credential => ({ ...credential, id: decode(credential.id) }))
  }
}

export function requestOptions(options) {
  return {
    ...options,
    challenge: decode(options.challenge),
    allowCredentials: (options.allowCredentials || []).map(credential => ({ ...credential, id: decode(credential.id) }))
  }
}

export function serializeCredential(credential) {
  const response = { clientDataJSON: encode(credential.response.clientDataJSON) }

  if (credential.response.attestationObject) {
    response.attestationObject = encode(credential.response.attestationObject)
  } else {
    response.authenticatorData = encode(credential.response.authenticatorData)
    response.signature = encode(credential.response.signature)
    response.userHandle = credential.response.userHandle ? encode(credential.response.userHandle) : null
  }

  return { id: credential.id, rawId: encode(credential.rawId), type: credential.type, response }
}
